/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The contact the owner typed when enrolling the home (TXN-3312), to prefill the contact step: the resident
 * confirms or corrects it and consents. Shown only to the holder of the resident's link.
 * @export
 * @interface HomeownershipContactPrefill
 */
export interface HomeownershipContactPrefill {
    /**
     * 
     * @type {string}
     * @memberof HomeownershipContactPrefill
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipContactPrefill
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof HomeownershipContactPrefill
     */
    phone?: string;
}

/**
 * Check if a given object implements the HomeownershipContactPrefill interface.
 */
export function instanceOfHomeownershipContactPrefill(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HomeownershipContactPrefillFromJSON(json: any): HomeownershipContactPrefill {
    return HomeownershipContactPrefillFromJSONTyped(json, false);
}

export function HomeownershipContactPrefillFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeownershipContactPrefill {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
    };
}

export function HomeownershipContactPrefillToJSON(value?: HomeownershipContactPrefill | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'email': value.email,
        'phone': value.phone,
    };
}

